import React, { useState } from "react";

import "./styles.css";
import logoCetim from "../../assets/images/logo_cetim_carnot.svg";
import pictoIa from "../../assets/images/picto-ia.png";

const svgContainerStyle = { width: '25px', flexShrink: 0 }; // flexShrink pour éviter que le conteneur SVG ne rétrécisse
const nouveauteTitleStyle = { height: '24px' }; // Hauteur spécifique pour le titre

const Infoia = ({ createLink, connectLink }) => { 

  const [isOpen, setIsOpen] = useState(false);
  
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  }
    
  return (
    <div>
      {!isOpen ? (
            <div id="chatbot-button-open" className="bulle" onClick={toggleOpen}>
                  <img className="" src={pictoIa} alt="chatbot" />
              </div>
        ) : (
                <div>
                <svg className="bulle" onClick={toggleOpen} width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="58" height="58" rx="29" fill="#EF3346"></rect>
                  <path d="M36.909 21.0908L21.0908 36.909M21.0908 21.0908L36.909 36.909" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              <div id="chatbot-modal-disconnected">

                      <img
                src={logoCetim}
                alt="Logo Cetim"
                className="logo-cetim"
              />
            
                  <div className="d-flex flex-row">
                    <div style={svgContainerStyle} className="me-3">
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12.5" cy="12.5" r="12.5" fill="#EF3346"></circle>
                        <path d="M14.4395 13.3945H11.7427V16.0914H14.4395V13.3945Z" fill="white"></path>
                        <path d="M5 10.6978V16.0915H7.69686V13.3946H11.7425V10.6978H5Z" fill="white"></path>
                        <path d="M18.1051 8.00081H11.7427V10.6977H17.1364V16.0914H19.8332V9.72811C19.8332 8.77387 19.0594 8 18.1051 8V8.00081Z" fill="white"></path>
                      </svg>
                    </div>

                    <div className="d-flex flex-column flex-grow-1">

                      <div className="d-flex flex-column mb-4">
                        <div className="text-custom-primary font-sourcesanspro d-flex flex-column">
                          <div
                            className="fw-bold lh-base mb-2"
                            style={nouveauteTitleStyle}
                          >
                            Nouveauté
                          </div>
                          <div className="lh-base" style={{ fontSize: '16px', lineHeight: '24px', fontWeight: '600' }}>
                            Découvrez l’IA générative de la Mécathèque qui simplifie vos recherches. Connectez-vous avec votre compte ressortissant pour y accéder. (accès réservé aux ressortissants)
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-row gap-3 justify-content-between">
                        <a
                          href={connectLink}
                          className="btn-custom btn-custom-blue w-100 rounded-1 fw-bold text-uppercase lh-1 font-sourcesanspro"
                          role="button"
                        >
                          Me connecter
                        </a>

                        <a
                          href={createLink}
                          className="btn-custom btn-custom-red w-100 rounded-1 fw-bold text-uppercase lh-1 font-sourcesanspro"
                          role="button"
                        >
                          Créer un compte
                        </a>
                      </div>
                    </div>
                  </div>
                </div>          
              </div>
            )}
          </div>
  );
}

export default Infoia;
